import { UserInfoResponse } from "../../proto/UserInfo_pb";
import store from "../../store";
import { addUsers } from "../../store/users/actions";
import BaseHandler from "../BaseHandler";

export default class HandleUserInfoResponse extends BaseHandler<UserInfoResponse> {
  handle() {
    //TODO FixBeforePush
    // const userInfoResponse = this.response.toObject();
    // console.log("userInfoResponse", userInfoResponse);
    // if (userInfoResponse?.user !== undefined) {
    //   store.dispatch(addUsers([userInfoResponse.user]));
    // }
  }
}
